const carouselItems = [
  {
    title: '星之妖精：星辰觉醒篇',
    desc: '全新篇章开启，主角觉醒星辰之力，踏上拯救妖精王国的冒险之旅。画风华丽升级，每一页都是视觉享受。',
    tag: '热门连载',
    img: 'https://readdy.ai/api/search-image?query=Epic%20manga%20illustration%20of%20a%20magical%20girl%20transforming%20with%20starry%20energy%20bursting%20from%20her%20body%20surrounded%20by%20constellations%20and%20galaxies%20against%20a%20deep%20cosmic%20background%20dramatic%20lighting%20with%20golden%20and%20silver%20sparkles%20beautiful%20anime%20art%20style%20highly%20detailed&width=800&height=400&seq=carousel-card-01&orientation=landscape',
  },
  {
    title: '魔导师传说：终章倒计时',
    desc: '连载超过200话的经典之作即将迎来大结局，最终决战一触即发，不容错过的史诗级收尾。',
    tag: '即将完结',
    img: 'https://readdy.ai/api/search-image?query=Epic%20final%20battle%20manga%20scene%20with%20an%20ancient%20wizard%20facing%20a%20massive%20dragon%20in%20a%20crumbling%20temple%20lightning%20and%20fire%20effects%20exploding%20everywhere%20cinematic%20wide%20angle%20shot%20dramatic%20orange%20and%20purple%20sky%20intense%20atmosphere%20highly%20detailed%20illustration&width=800&height=400&seq=carousel-card-02&orientation=landscape',
  },
  {
    title: '精灵之森：动画化决定',
    desc: '人气奇幻漫画《精灵之森》确认动画化！官方已公布制作阵容，预计明年与观众见面。',
    tag: '重磅新闻',
    img: 'https://readdy.ai/api/search-image?query=Magical%20forest%20manga%20illustration%20with%20elegant%20elf%20characters%20gathered%20around%20an%20ancient%20glowing%20tree%20in%20the%20center%20of%20an%20enchanted%20forest%20bioluminescent%20plants%20and%20floating%20light%20orbs%20surrounding%20them%20soft%20ethereal%20green%20and%20golden%20lighting%20dreamy%20fantasy%20atmosphere&width=800&height=400&seq=carousel-card-03&orientation=landscape',
  },
  {
    title: '萌系新星：《猫耳咖啡厅》开载',
    desc: '超人气萌系新作正式登陆妖精漫画网！猫耳少女与咖啡厅的温馨日常，开篇即引爆讨论。',
    tag: '新作首发',
    img: 'https://readdy.ai/api/search-image?query=Cute%20manga%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20adorable%20cat-eared%20characters%20serving%20coffee%20and%20pastries%20warm%20sunlight%20streaming%20through%20large%20windows%20plants%20and%20bookshelves%20in%20the%20background%20soft%20pastel%20colors%20with%20cream%20and%20mint%20green%20accents%20wholesome%20atmosphere&width=800&height=400&seq=carousel-card-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          本周重点推荐与重磅资讯，精彩内容一网打尽
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}